import { useContext } from 'react'

import { Helmet } from 'react-helmet-async'

import { faGlobe } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Columns, DashboardModule, LoadingModule,
} from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useServiceCategory'
import useServiceCategories from '@hooks/useServiceCategories'

import ListBlankState from '@components/ListBlankState'
import PageFilterModule from '@components/PageFilterModule'
import PageHeader from '@components/PageHeader'

import PageContext from '@contexts/pageContext'

import ServiceCategoryListItem from '../ServiceCategoryListItem'

const buildPageFilterFields = () => {
  const style = { marginBottom: 16 }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title or ID',
    },
  ]
}
interface PageContentProps {
  pageFilters: {
    [key: string]: any,
  },
}

const PageContent = (props: PageContentProps) => {
  const { pageFilters } = props

  const serviceCategoriesPayload = useServiceCategories({
    filters: pageFilters,
    performHttpRequests: true,
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredServiceCategories,
    filteredServiceCategoriesCount,
    hasFilteredServiceCategories,
    loading,
  } = serviceCategoriesPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      resetFilters,
      showCreateOrEditServiceCategoryModal,
      updateFilters,
    },
    defaultFilters,
  } = pageContext

  const { serviceCategoriesIndexUrl } = generateUrls()

  return (
    <>
      <Helmet>
        <title>Service Categories | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            buttonStyle="primaryCreate"
            onClick={() => showCreateOrEditServiceCategoryModal()}
            size="medium"
          >
            Create
          </Button>
        )}
        activeTabBarItemKey="serviceCategories"
        tabBarItems={[
          {
            href: serviceCategoriesIndexUrl,
            icon: faGlobe,
            key: 'serviceCategories',
            title: 'Service Categories',
          },
        ]}
        title="Service Categories"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredServiceCategories && <ListBlankState />}

            {!loading && hasFilteredServiceCategories && (
              <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Service Categories">
                <Box flexDirection="column">
                  {filteredServiceCategories.map(serviceCategory => (
                    <ServiceCategoryListItem key={serviceCategory.id} serviceCategory={serviceCategory} />
                  ))}
                </Box>

                <DashboardModule.LoadMoreFooter
                  callbacks={{ loadMore }}
                  canLoadMore={canLoadMore}
                  entityCount={filteredServiceCategoriesCount}
                  loading={loading}
                />
              </DashboardModule>
            )}
          </Columns.Main>

          <Columns.Sidebar>
            <PageFilterModule
              callbacks={{ resetFilters, updateFilters }}
              defaultFilters={defaultFilters}
              // @ts-expect-error TS2322
              filterFields={buildPageFilterFields()}
              pageFilters={pageFilters}
              title="Filters"
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
